import { useMutation } from 'react-query';
import { BASE_API_URL } from '@env';

export function useSignUp() {
  const mutation = useMutation(async ({ email, password, fullName }: { email: string; password: string; fullName: string }) => {
    const nameParts = fullName.trim().split(/\s+/);
    const first_name = nameParts[0];
    const last_name = nameParts.slice(1).join(' ');
    const payload = {
      email: email.trim(),
      password,
      first_name,
      last_name,
    };
    const response = await fetch(`${BASE_API_URL}/users/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || errorData.detail || 'Signup failed');
    }
    return response.json();
  });

  return mutation;
} 